import {
    Component,
    Input,
    ViewChild,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { RouterLink } from "@angular/router";
import { ListColumnCheckboxDirective } from "@components/list/list-column-checkbox.directive";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent as ListComponent_1 , ListComponent } from "@components/list/list.component";
import { TranslatePipe } from "@ngx-translate/core";

import { FeatureService } from "~app/common/services/feature.service";
import { ISearchHandelssortimentModel } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";
import { HandelssortimentSearchResultViewModel } from "./handelssortiment-search-result-view-model";

@Component({
    selector: "rask-search-result",
    styleUrls: ["./search-result.component.scss"],
    templateUrl: "./search-result.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent_1,
        ListColumnCheckboxDirective,
        ListColumnDirective,
        RouterLink,
        TranslatePipe
    ]
})
export class SearchResultComponent {
    handelssortiment: HandelssortimentSearchResultViewModel[];
    @ViewChild("hssearchresult") searchResultTable: ListComponent;
    selectedRows: HandelssortimentSearchResultViewModel[];
    private readonly featureService = inject(FeatureService);

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("handelssortiment") set list(val: ISearchHandelssortimentModel[]) {
        if (!val) {
            return;
        }

        this.handelssortiment = val.map(x => new HandelssortimentSearchResultViewModel(x));
    }

    onCheckedChange() {
        this.selectedRows = this.searchResultTable.getSelectedRows();
    }
}
